import React from 'react';
import ReactJson, { InteractionProps } from 'react-json-view';
import { showError } from '../../../../../store/popup/actions';
import { t } from '../../../../../helpers/i18n';
import { useDispatch } from 'react-redux';
import './ProjectConfigJsonView.scss';

interface ProjectConfigJsonViewProps {
  extraConfig?: any;
  onJsonDataChanged: (any: any) => void;
}

const ProjectConfigJsonView: React.FC<ProjectConfigJsonViewProps> = (props) => {
  const dispatch = useDispatch();
  const { extraConfig, onJsonDataChanged } = props;

  return (
    <div className={'json-view-container'}>
      <ReactJson
        src={extraConfig}
        name={null}
        iconStyle="circle"
        displayDataTypes={false}
        validationMessage={''}
        displayObjectSize={true}
        collapseStringsAfterLength={50}
        enableClipboard={true}
        onEdit={(edit: InteractionProps) => {
          if (typeof edit.new_value !== 'string') {
            dispatch(showError(t(t('Error accept JSON string map only'))));
            return false;
          }

          onJsonDataChanged(edit.updated_src);
          return true;
        }}
        onAdd={(add: InteractionProps) => {
          onJsonDataChanged(add.new_value);
          return true;
        }}
        onDelete={(del: InteractionProps) => {
          onJsonDataChanged(del.updated_src);
          return true;
        }}
      />
    </div>
  );
};

export default ProjectConfigJsonView;
